import { render, staticRenderFns } from "./SponsoringBat.vue?vue&type=template&id=4c925c9e&scoped=true&"
import script from "./SponsoringBat.vue?vue&type=script&lang=ts&"
export * from "./SponsoringBat.vue?vue&type=script&lang=ts&"
import style0 from "./SponsoringBat.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SponsoringBat.vue?vue&type=style&index=1&id=4c925c9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c925c9e",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCard,VCol,VRow,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/builds/riverline/optincollect-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c925c9e')) {
      api.createRecord('4c925c9e', component.options)
    } else {
      api.reload('4c925c9e', component.options)
    }
    module.hot.accept("./SponsoringBat.vue?vue&type=template&id=4c925c9e&scoped=true&", function () {
      api.rerender('4c925c9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/campaign/SponsoringBat.vue"
export default component.exports